import shuffle from 'lodash/shuffle';
import { add, type Duration, isBefore, isWithinInterval } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export type ScheduleItem = {
	startDate: string;
	endDate: string;
	type: string;
	label: string;
	backgroundColor: string;
};

const users = [
	{
		label: 'Alana',
		backgroundColor: token('color.background.accent.blue.subtle', colors.B200),
	},
	{
		label: 'Will',
		backgroundColor: token('color.background.accent.red.subtle', colors.R200),
	},
	{
		label: 'Emma',
		backgroundColor: token('color.background.accent.green.subtle', colors.G300),
	},
	{
		label: 'Harvey',
		backgroundColor: token('color.background.accent.yellow.subtle', colors.Y300),
	},
	{
		label: 'José',
		backgroundColor: token('color.background.accent.purple.subtle', colors.P300),
	},
	{
		label: 'Mia',
		backgroundColor: token('color.background.accent.teal.subtle', colors.T300),
	},
];

export const createMockSchedules = (
	start: Date,
	end: Date,
	defaultDuration: Duration,
	timezone?: string,
): ScheduleItem[] => {
	const userList = shuffle(users);
	const result: Array<ScheduleItem> = [];

	let counter = 0;
	const currentDate = timezone == null ? new Date() : utcToZonedTime(new Date(), timezone);
	const periodStartDate = timezone == null ? start : utcToZonedTime(start, timezone);
	let startDate = periodStartDate;
	let endDate = add(startDate, defaultDuration);

	let type = isBefore(periodStartDate, currentDate) ? 'historical' : 'default';
	while (isBefore(startDate, end)) {
		const splitAtCurrent = isWithinInterval(currentDate, {
			start: startDate,
			end: endDate,
		});

		if (splitAtCurrent) {
			result.push(
				{
					startDate: startDate.toISOString(),
					endDate: currentDate.toISOString(),
					type,
					...userList[counter % userList.length],
				},
				{
					startDate: currentDate.toISOString(),
					endDate: endDate.toISOString(),
					type: 'default',
					...userList[counter % userList.length],
				},
			);

			type = 'default';
		} else {
			result.push({
				startDate: startDate.toISOString(),
				endDate: endDate.toISOString(),
				type,
				...userList[counter % userList.length],
			});
		}

		counter += 1;

		startDate = add(startDate, defaultDuration);
		endDate = add(endDate, defaultDuration);
	}

	return result;
};
